import { Splitter } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import AppointmentsFilters from './AppointmentsFilters'
import { get } from '../../Common/api'
import AppointmentHistoryList from './AppointmentHistoryList'
import Title from 'antd/es/typography/Title'
import GlobalContext from '../GlobalContext'

export default function AppointmentsHistoryPage () {
  const { appointments } = useContext(GlobalContext)
  const [searchedAppointments, setSearchedAppointments] = useState([])
  const [filter, setFilter] = useState()
  const [loading, setLoading] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  const getAppointments = async () => {
    filter.scope = 'history'
    setLoading(true)
    await get({
      url: 'admin/appointments',
      params: filter,
      onSuccess: (json) => {
        setSearchedAppointments(json)
        setLoading(false)
        setCollapsed(true)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (filter) {
      getAppointments()
    }
  }, [filter])

  useEffect(() => {
    setSearchedAppointments(
      searchedAppointments.map((appointment) => {
        const s = appointments.find((s) => s.id === appointment.id)
        return s ? { ...appointment, ...s } : appointment
      })
    )
  }, [appointments])

  return (
    <Splitter orientation='vertical' style={{ height: '87vh' }} onCollapse={() => setCollapsed(!collapsed)}>
      <Splitter.Panel
        collapsible={{ start: true, end: true, showCollapsibleIcon: true }}
        max='20%'
        resizable={false}
        size={collapsed ? '0%' : '20%'}
      >
        <AppointmentsFilters setFilter={setFilter} />
      </Splitter.Panel>
      <Splitter.Panel>
        <Title level={4} >{`${searchedAppointments.length} Résultats`}</Title>
        <AppointmentHistoryList
          appointments={searchedAppointments}
          loading={loading}
          collapsed={collapsed}
        />
      </Splitter.Panel>
    </Splitter>
  )
}
